import { create } from 'zustand';
import { AccountApi, ApiUtils, RequestStrategyEnum } from '@shared/api';

interface IApproveRequestStore {
  loading: boolean;
  error: string | null;
  success: boolean;
  approveRequest: (requestId: string, signal?: AbortSignal) => Promise<void>;
  clear: () => void;
}

export const useApproveRequestStore = create<IApproveRequestStore>((set) => ({
  loading: false,
  error: null,
  success: false,

  approveRequest: ApiUtils.wrapperApi(async (requestId: string, signal?: AbortSignal) => {
    try {
      set({ loading: true, error: null });
      await AccountApi.approveRequest(requestId, signal);
      set({ success: true, loading: false });
    } catch (error) {
      set({ error: (error as Error).message, loading: false });
    }
  }, RequestStrategyEnum.Debounce),

  clear: () => set({ success: false, loading: false, error: null }),
}));
